var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"toggle-button",class:{ active: _vm.value, small: _vm.size === 'small', disabled: _vm.disabled },attrs:{"type":"button","role":"switch","aria-checked":_vm.value.toString()},on:{"click":_vm.onClick}},[_c('span',{class:{ active: _vm.value },attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }